import React from 'react'

export default function HaldiCraft({haldiCraft}) {
  return (
    <>
    <section className="haldipage-craft">
        <div className="container">
            <div className="row justify-content-center">

                <div className="col-lg-10 col-md-10">
                    <h4 className='heading'>{haldiCraft?.heading}</h4>
                    <p className="wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">{haldiCraft?.description}</p>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
